module.exports = __webpack_public_path__ + "img/academy.59ee7bfa.png";